<template>
    <div class="header" v-if="$root.isHasHeader">
        <van-nav-bar :fixed="isFixed" :title="title ? title : $route.meta.title">
            <slot name="left" slot="left"></slot>
            <slot name="right" slot="right"></slot>
        </van-nav-bar>
        <div class="header-placeholder" v-if='isFixed'></div>
    </div>
</template>
<script>
// import { getSystem } from '@/utils'

export default {
  name: 'navbar',
  props: {
    title: String,
    isFixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isHas: false
    }
  },
  created () {
    // this.isHas = true
  }
}
</script>
<style lang='less' scoped >
.ph-nav-bar {
  top: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 10;
}
.header-placeholder{
  height:92px;
}
</style>
